<template>
  <div class="container-fluid">
    <div class="col justify-content-center">
      <div class="d-flex justify-content-center mb-3">
        <b-form-group label="Choisir le type :" class="mb-0">
          <b-form-radio-group
            v-model="selectedType"
            :options="typeOptions"
            buttons
            button-variant="primary"
            class=""
          ></b-form-radio-group>
        </b-form-group>
      </div>
      <div v-if="selectedType === 'stat'">
        <Selecteur
          v-if="selectShow"
          :clients="clients"
          @search="filterRapport"
          key="selectGame"
        />
        <div v-if="chartShow" class="col-12">
          <GameRadarChart :data="rapport" />
        </div>
        <div v-if="chartShow" class="col-12">
          <div class="row align-items-center">
            <div class="col-3 mx-auto">
              <LevelPieChart :data="rapport" />
            </div>
            <div class="col-3 mx-auto">
              <PlayersPieChart :data="rapport" />
            </div>
            <div class="col-3 mx-auto">
              <RegisterPieChart :data="rapport" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedType === 'question'">
        <Selecteur
          v-if="selectShow"
          :clients="clients"
          @search="filterQuestion"
          key="selectQuestion"
        />
        <ArrayTable
          v-if="arrayQuestionShow"
          :dataTable="dataTableQuestion"
          :options="{ perPage: 20 }"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  import GameRadarChart from '../components/divers/GameRadarChart.vue'
  import LevelPieChart from '../components/divers/LevelPieChart.vue'
  import PlayersPieChart from '../components/divers/PlayersPieChart.vue'
  import RegisterPieChart from '../components/divers/RegisterPieChart.vue'
  import Selecteur from '../components/divers/Selecteur.vue'
  import ArrayTable from '../components/divers/ArrayTable.vue'

  export default {
    name: 'Rapport',
    components: {
      RegisterPieChart,
      LevelPieChart,
      PlayersPieChart,
      GameRadarChart,
      Selecteur,
      ArrayTable,
    },
    data() {
      return {
        token: null,
        rapport: {},
        clients: [],

        chartShow: false,
        arrayQuestionShow: false,
        selectShow: false,
        typeOptions: [
          { value: 'stat', text: 'Stat' },
          { value: 'question', text: 'Question' },
        ],
        selectedType: 'stat',
        dataTableQuestion: {
          items: [],
          fields: [
            { key: '_id', label: 'ID', sortable: true },
            { key: 'theme', label: 'Theme', sortable: true },
            { key: 'totalSuccess', label: 'Success', sortable: true },
            { key: 'margingError', label: "Marge D'erreur", sortable: true },
            { key: 'totalPlayed', label: 'Total', sortable: true },
          ],
        },
      }
    },
    methods: {
      async allRapportData() {
        let data
        let params = {
          filtered: false,
        }
        try {
          data = await axios.get('/api/rapport/datas', {
            headers: this.headers,
            params: params,
          })
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Récupération du rapport général',
            text: error ? error : 'Erreur inconnue.',
          })
        }
        this.rapport = data.data.playedData[0]
        this.chartShow = true
      },
      async allRapportQuestion() {
        let data
        let params = {
          filtered: false,
        }
        try {
          data = await axios.get('/api/rapport/questions', {
            headers: this.headers,
            params: params,
          })
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Récupération du rapport des questions',
            text: error ? error : 'Erreur inconnue.',
          })
        }

        this.dataTableQuestion.items = data.data.playedQuestion
        this.arrayQuestionShow = true
      },
      async allClientData() {
        let data
        try {
          data = await axios.get('/api/rapport/clients', {
            headers: this.headers,
          })
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Récupération des données client',
            text: error ? error : 'Erreur inconnue.',
          })
        }
        this.clients = data.data.sendData
        this.selectShow = true
      },
      async filterRapport({ startDate, endDate, selectedClient }) {
        this.chartShow = false
        let params = {
          filtered: true,
          startDate: startDate,
          endDate: endDate,
          roomId: null,
        }
        this.clients.forEach((client) => {
          if (selectedClient === client._id) {
            params.roomId = client.roomsId
          }
        })
        let data
        try {
          data = await axios.get('/api/rapport/datas', {
            headers: this.headers,
            params: params,
          })
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Récupération du rapport filtré',
            text: error ? error : 'Erreur inconnue.',
          })
        }
        if (data.data.playedData.length > 0) {
          this.rapport = data.data.playedData[0]
        } else {
          this.$notify({
            type: 'error',
            title: 'Récupération du rapport filtré',
            text: 'le rapport est revenue vide',
          })
        }
        this.chartShow = true
      },
      async filterQuestion({ startDate, endDate, selectedClient }) {
        this.arrayQuestionShow = false
        let params = {
          filtered: true,
          startDate: startDate,
          endDate: endDate,
          roomId: null,
        }
        this.clients.forEach((client) => {
          if (selectedClient === client._id) {
            params.roomId = client.roomsId
          }
        })
        let data
        try {
          data = await axios.get('/api/rapport/questions', {
            headers: this.headers,
            params: params,
          })
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Récupération du rapport filtré',
            text: error ? error : 'Erreur inconnue.',
          })
        }
        if (data.data.playedQuestion.length > 0) {
          this.dataTableQuestion.items = data.data.playedQuestion
        } else {
          this.$notify({
            type: 'error',
            title: 'Récupération du rapport filtré',
            text: 'le rapport est revenue vide',
          })
        }
        this.arrayQuestionShow = true
      },
    },
    computed: {
      headers() {
        return {
          Authorization: 'Bearer ' + this.token,
        }
      },
    },
    mounted() {
      this.token = localStorage.getItem('jwt')
      if (!this.token) {
        this.$router.push('/login')
      }
      this.allRapportData()
      this.allRapportQuestion()
      this.allClientData()
    },
  }
</script>

<style scoped>
  .container-fluid {
    max-width: 1400px;
  }
</style>
